import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import './../../ui.style.scss'
import {
  Form,
  Input, Checkbox, message
} from 'antd'
import { utilityService } from './../../../../services/UtilityService'
import userMessages from '../../../../constants/messages'
import LoadingButton from './../../general/buttons/LoadingButton'

const LoginForm = ({ onSelect, onForgotClick, isLoginFormLoading }) => {
  // Individual States
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [isValidUserName, setIsValidUserName] = useState(true)
  const [isValidPassword, setIsValidPassword] = useState(true)
  // const [errorMessage, setErrorMessage] = useState('')
  const [disabled, setDisabled] = useState(true)
  const [shouldRember, setShouldRember] = useState(true)

  // Handle Button Disabled status (replaces checkFormStatus)
  useEffect(() => {
    setDisabled(!(username && password))
  }, [username, password])

  const handleSubmit = (e) => {
    e.preventDefault()
    if (isLoginFormLoading) return

    let validPass = true
    let validUser = true
    let errorMsg = ''

    const email = username.toLowerCase()

    if (email && password) {
      validUser = utilityService.checkEmailValidation(email)
      validPass = utilityService.checkPasswordValidation(password)

      if (!validUser && !validPass) {
        errorMsg = userMessages.LOGIN_EMAIL_PASSWORD_VALIDATION_FAILURE
      } else if (validUser && validPass) {
        onSelect(email, password, shouldRember)
      } else {
        errorMsg = validUser
          ? userMessages.LOGIN_PASSWORD_VALIDATION_FAILURE
          : userMessages.LOGIN_EMAIL_VALIDATION_FAILURE
      }
    } else {
      validUser = !!email
      validPass = !!password
      errorMsg = userMessages.AUTH_EMPTY_FIELD
    }

    if (errorMsg) {
      message.warning(errorMsg)
    }

    setIsValidUserName(validUser)
    setIsValidPassword(validPass)
    // setErrorMessage(errorMsg)
  }

  const handleLoginformChange = e => {
    const { name, value } = e.target
    if (name === 'username') setUsername(value)
    if (name === 'password') setPassword(value)
  }

  const onRemembeMeChange = () => {
    setShouldRember(prev => !prev)
  }

  const isHyperion = window.location.href.includes('hyperion')
  const isSubhub = window.location.href.includes('subhub')

  return (
    <div className={`login-form ${isLoginFormLoading ? 'loading' : ''}`} >
      {isHyperion ? (
        <div className='optus-logo hyperion-logo'><span>HYPERION</span></div>
      ) : isSubhub ? (
        <div className='optus-logo hyperion-logo'><span>SUBHUB</span></div>
      ) : (
        <img className='optus-logo' src={require('./../../../../assets/images/optus-logo.png')} alt='logo' />
      )}

      <span>SIGN IN</span>
      <div className='border-line' />

      <Form onSubmit={handleSubmit} autocomplete='off'>
        <Form.Item label='Email'>
          <Input
            className={`email ${!isValidUserName ? 'error' : ''}`}
            placeholder='Enter your email'
            name='username'
            onChange={handleLoginformChange}
            value={username}
            autocomplete='off'
            type='text'
          />
        </Form.Item>
        <Form.Item label='Password'>
          <Input
            className={`password ${!isValidPassword ? 'error' : ''}`}
            type='text'
            name='password'
            placeholder='Enter your password'
            value={password}
            onChange={handleLoginformChange}
            style={{
              WebkitTextSecurity: 'disc'
            }}
          />
        </Form.Item>
        <Form.Item>
          <LoadingButton
            type='primary'
            htmlType='submit'
            buttonText='Sign In'
            buttonClass='login-form-button'
            isLoading={isLoginFormLoading}
            isDisabled={disabled}
          />
          <div className='login-form-down'>
            <Checkbox checked={shouldRember} onChange={onRemembeMeChange}>
              Stay signed in
            </Checkbox>
            <a className='login-form-forgot' onClick={onForgotClick}>
              Forgot password?
            </a>
          </div>
        </Form.Item>
      </Form>
    </div>
  )
}

LoginForm.propTypes = {
  onSelect: PropTypes.func.isRequired,
  onForgotClick: PropTypes.func.isRequired,
  formSuccess: PropTypes.bool
}

export default LoginForm
